import {
  ListItem,
  ListItemButton,
  ListItemText,
  Popover,
  Theme,
  useMediaQuery,
} from '@mui/material';
import { RefObject, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { UserClass } from '@work4all/models/lib/Enums/UserClass.enum';

interface CreateUserActionProps {
  open: boolean;
  onCreate: (action: UserClass) => void;
  onClose: () => void;
  rootRef?: RefObject<HTMLButtonElement>;
}

export const CreateUserAction = (props: CreateUserActionProps) => {
  const { open, onCreate, onClose, rootRef } = props;
  const { t } = useTranslation();

  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );

  const groups = useMemo(() => {
    return [UserClass.BENUTZER, UserClass.MITARBEITER, UserClass.RESSOURCE].map(
      (x) => ({
        id: x,
        name: t(`ENUMS.${x.toUpperCase()}`),
      })
    );
  }, [t]);

  const onClick = (action: UserClass) => {
    onClose();
    onCreate(action);
  };

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={rootRef.current}
      anchorOrigin={{
        vertical: isMobile ? 'top' : 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={
        isMobile && {
          vertical: 'bottom',
          horizontal: 'left',
        }
      }
      sx={isMobile && { mt: -0.5 }}
    >
      {groups.map((action) => (
        <ListItem key={action.id} disablePadding>
          <ListItemButton role={undefined} onClick={() => onClick(action.id)}>
            <ListItemText primary={action.name} />
          </ListItemButton>
        </ListItem>
      ))}
    </Popover>
  );
};
